// src/components/common/ProtectedRoute.js - VERSIÓN CON SEGURIDAD MEJORADA

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isSuperAdminEmail } from '../../config/superAdmin';
import AppBootstrapSplash from './AppBootstrapSplash';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, orgId, currentUser } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <AppBootstrapSplash
        productName="0E3 POS"
        message="Preparando tu espacio de trabajo..."
        showVersion={false}
        fullViewport
      />
    );
  }
  if (!isAuthenticated) return <Navigate to="/login" replace state={{ from: location }} />;
  if (isSuperAdminEmail(currentUser?.email)) return children;

  const hasVerifiedPhone = Boolean(String(currentUser?.phoneNumber || '').trim());
  const isDemoSyntheticUser = /@nexopos\.demo\.local$/i.test(
    String(currentUser?.email || '').trim()
  );
  if (currentUser && !currentUser.emailVerified && !hasVerifiedPhone && !isDemoSyntheticUser) {
    if (location.pathname !== '/verificar-email') {
      return <Navigate to="/verificar-email" replace state={{ from: location }} />;
    }
    return children;
  }

  const claimOrgId = String(
    currentUser?.orgId ||
      currentUser?.companyId ||
      currentUser?.customClaims?.companyId ||
      currentUser?.customClaims?.orgId ||
      ''
  ).trim();
  const effectiveOrgId = orgId || claimOrgId || null;

  // Sin org real: verificar-email (invitado) o configuración. Evitar empujar a "crear empresa"
  // solo porque orgId de estado aún no hidrató desde usuariosOrg/claims.
  const rutasSinOrg = ['/configuracion/empresa', '/verificar-email'];
  if (!effectiveOrgId && !rutasSinOrg.includes(location.pathname)) {
    if (!currentUser?.emailVerified && !hasVerifiedPhone && !isDemoSyntheticUser) {
      return <Navigate to="/verificar-email" replace />;
    }
    return <Navigate to="/configuracion/empresa" replace />;
  }

  return children;
};

export default ProtectedRoute;